module.exports = __webpack_public_path__ + "media/img/corporate/logos/vaudoise-f382248df1e3d018dd3206db162632ea.svg";